import moment from "moment";

export const combineDateAndTimeWithLocalTimezone = <T extends Date | null>(date: T, time: string): T => {
    if (!date || !time) return null as null as T;

    const [hours, minutes] = time.split('h').map(Number);
    const utcDate = moment.utc(date);

    return new Date(utcDate.year(), utcDate.month(), utcDate.date(), hours, minutes, 0, 0) as Date as T;
};